// Copyright (c) 2016 Deere & Company

import './warranty-modal.scss';
import React, {PropTypes} from 'react';
import WarrantyLargeModal from './large-modal';

const WarrantySimpleModal = props =>
    <WarrantyLargeModal
        {...props}
        simple={true}
    />;

WarrantySimpleModal.displayName = 'WarrantySimpleModal';
WarrantySimpleModal.propTypes = {
    isOpen: PropTypes.bool.isRequired
};

export default WarrantySimpleModal;



// WEBPACK FOOTER //
// ./src/shared/components/modal/simple-modal.js